import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionTag = ({ children, tone = "orange" }) => {
    const tones = {
        orange: "bg-[#F57A3A] text-[#F7F4EC]",
        yellow: "bg-[#F1C75B] text-[#1A231E]",
        green: "bg-[#0E6B3F] text-[#F7F4EC]",
        beige: "bg-[#F7F4EC] text-[#0E6B3F]",
    };
    return (
        <span
            className={`inline-block text-xs font-bold uppercase tracking-[0.16em] px-4 py-1.5 rounded-full sticker ${tones[tone]}`}
            style={{ transform: "rotate(-1.5deg)" }}
        >
            {children}
        </span>
    );
};
